import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import { dashboardActions } from '../../../../store/slices/dashboardSlice/dashboardSlice';
import { getManager } from '../../helpers/getManager';
import { ManagerInformation } from '../../types/dashboardInformation';
import { deleteManager } from '../../../../store/slices/dashboardSlice/action';

export const useModalShowManagerInfo = () => {
    const dispatch = useDispatch();
    //@ts-ignore
    const { modalMode, modalLoader, currentManagerId, is_customer, can_show_financial_info } =
        useSelector(
            //@ts-ignore
            (state) => state.dashboardReducer
        );
    const [managerInfo, setManagerInfo] = useState<ManagerInformation>({
        full_name: '',
        position: '',
        email: '',
        phone: '',
        estimates_access: true,
        preview_url: null,
    });
    const [isShowPopup, setIsShowPopup] = useState(false);

    const onHidePopup = () => {
        setIsShowPopup(false);
    };

    const onShowPopup = () => {
        setIsShowPopup(true);
    };

    const onCancel = useCallback(() => {
        dispatch(dashboardActions.onModalMode(null));
    }, []);

    const onDelete = useCallback(() => {
        dispatch(deleteManager(currentManagerId));
        setIsShowPopup(false);
    }, [dispatch, currentManagerId]);

    const onClickEditMode = useCallback(() => {
        dispatch(dashboardActions.onModalMode('editManagerInfo'));
    }, [dispatch, currentManagerId]);

    useEffect(() => {
        if (modalMode === 'showManagerInfo') {
            const fetchManagerInfo = async () => {
                try {
                    dispatch(dashboardActions.onModalLoader(true));
                    const data = await getManager(currentManagerId);
                    setManagerInfo(data);
                } catch (error) {
                    console.error(error.message);
                    dispatch(dashboardActions.onModalMode(null));
                } finally {
                    dispatch(dashboardActions.onModalLoader(false));
                }
            };

            fetchManagerInfo();
        }
    }, [modalMode, currentManagerId, dispatch, setManagerInfo]);

    return {
        modalMode,
        onCancel,
        onClickEditMode,
        modalLoader,
        managerInfo,
        onDelete,
        is_customer,
        can_show_financial_info,
        isShowPopup,
        onHidePopup,
        onShowPopup,
    };
};
